import { RelationTypeWith } from '../../types';

export const GrandSonMatriarchal = [
	RelationTypeWith.GRAND_SON_MATRIARCHAL, // 主被保人与投保人是外孙关系
	new Map<RelationTypeWith, RelationTypeWith | RelationTypeWith[]>([
		// 外孙的配偶 -> 其他
		[RelationTypeWith.SPOUSE, RelationTypeWith.OTHER],
		// 外孙的子女 -> 其他
		[RelationTypeWith.CHILD, RelationTypeWith.OTHER],
		// 外孙的父母 -> 子女, 其他
		[
			RelationTypeWith.PARENTS,
			[RelationTypeWith.CHILD, RelationTypeWith.SON, RelationTypeWith.DAUGHTER, RelationTypeWith.OTHER]
		],
		// 外孙的(外)祖父母 -> 自己, 配偶, 其他
		[
			RelationTypeWith.GRAND_PARENT,
			[
				RelationTypeWith.SELF,
				RelationTypeWith.SPOUSE,
				RelationTypeWith.WIFE,
				RelationTypeWith.HUSBAND,
				RelationTypeWith.OTHER
			]
		],
		// 外孙的孙辈 -> 其他
		[RelationTypeWith.GRAND_CHILDREN, RelationTypeWith.OTHER],
		// 外孙的养父母 -> 其他
		[RelationTypeWith.FOSTER_PARENT, RelationTypeWith.OTHER],
		// 外孙的雇员 -> 其他, 雇员
		[RelationTypeWith.EMPLOY, [RelationTypeWith.OTHER, RelationTypeWith.EMPLOY]],
		// 外孙的法定继承人 -> 自己, 子女, 孙辈, 祖辈, 其他
		[
			RelationTypeWith.HEIR_AT_LAW,
			[
				RelationTypeWith.OTHER,
				RelationTypeWith.CHILD,
				RelationTypeWith.SON,
				RelationTypeWith.DAUGHTER,
				RelationTypeWith.SELF,
				RelationTypeWith.SPOUSE,
				RelationTypeWith.HUSBAND,
				RelationTypeWith.WIFE,
				RelationTypeWith.GRAND_CHILDREN,
				RelationTypeWith.GRAND_DAUGHTER_MATRIARCHAL,
				RelationTypeWith.GRAND_SON_MATRIARCHAL,
				RelationTypeWith.PARENTS,
				RelationTypeWith.FATHER,
				RelationTypeWith.MOTHER,
				RelationTypeWith.GRAND_PARENT,
				RelationTypeWith.GRAND_FATHER_PARTRILOCAL,
				RelationTypeWith.GRAND_FATHER_MATRIARCHAL,
				RelationTypeWith.GRAND_MOTHER_PARTRILOCAL,
				RelationTypeWith.GRAND_MOTHER_MATRIARCHAL
			]
		],
		// 外孙的兄弟姐妹 -> 孙辈, 其他
		[
			RelationTypeWith.SIBLING,
			[
				RelationTypeWith.GRAND_CHILDREN,
				RelationTypeWith.GRAND_SON_MATRIARCHAL,
				RelationTypeWith.GRAND_DAUGHTER_MATRIARCHAL,
				RelationTypeWith.OTHER
			]
		],
		// 外孙的妻子 -> 其他
		[RelationTypeWith.WIFE, RelationTypeWith.OTHER],
		// 外孙的儿子 -> 其他
		[RelationTypeWith.SON, RelationTypeWith.OTHER],
		// 外孙的女儿 -> 其他
		[RelationTypeWith.DAUGHTER, RelationTypeWith.OTHER],
		// 外孙的父亲 -> 其他
		[RelationTypeWith.FATHER, RelationTypeWith.OTHER],
		// 外孙的母亲 -> 女儿, 其他
		[RelationTypeWith.MOTHER, [RelationTypeWith.DAUGHTER, RelationTypeWith.CHILD, RelationTypeWith.OTHER]],
		// 外孙的孙子 -> 其他
		[RelationTypeWith.GRAND_SON_PARTRILOCAL, RelationTypeWith.OTHER],
		// 外孙的孙女 -> 其他
		[RelationTypeWith.GRAND_DAUGHTER_PARTRILOCAL, RelationTypeWith.OTHER],
		// 外孙的外孙 -> 其他
		[RelationTypeWith.GRAND_SON_MATRIARCHAL, RelationTypeWith.OTHER],
		// 外孙的外孙女 -> 其他
		[RelationTypeWith.GRAND_DAUGHTER_MATRIARCHAL, RelationTypeWith.OTHER],
		// 外孙的祖父 -> 其他
		[RelationTypeWith.GRAND_FATHER_PARTRILOCAL, RelationTypeWith.OTHER],
		// 外孙的祖母 -> 其他
		[RelationTypeWith.GRAND_MOTHER_PARTRILOCAL, RelationTypeWith.OTHER],
		// 外孙的外祖父 -> 自己, 配偶, 其他
		[
			RelationTypeWith.GRAND_FATHER_MATRIARCHAL,
			[RelationTypeWith.SELF, RelationTypeWith.HUSBAND, RelationTypeWith.SPOUSE, RelationTypeWith.OTHER]
		],
		// 外孙的外祖母 -> 自己, 配偶, 其他
		[
			RelationTypeWith.GRAND_MOTHER_MATRIARCHAL,
			[RelationTypeWith.SELF, RelationTypeWith.WIFE, RelationTypeWith.SPOUSE, RelationTypeWith.OTHER]
		]
	])
] as [RelationTypeWith.GRAND_SON_MATRIARCHAL, Map<RelationTypeWith, RelationTypeWith | RelationTypeWith[]>];
